<div class="container">
  <mat-card class="card2">
   
          <h4 class="card-title">Add Dish</h4>
      
      <form (ngSubmit)="f.form.valid" #f="ngForm">
        <div class="row">
          
          <div class="col-md-4">
                  <mat-form-field class="example-full-width">
          
              <mat-label>Name</mat-label>
              <input matInput placeholder="Name" name="name" [(ngModel)]="addForm.name" #firstName="ngModel" [ngClass]="{ 'is-invalid': f.submitted && firstName.invalid }" required>
              
            </mat-form-field>
            <div
            [hidden]="firstName.valid || firstName.pristine"
            class="erro1"
          >Name is Required
          </div>
          </div>
            <div class="col-md-4">
            <mat-form-field class="example-full-width">
              <mat-label>Select Type</mat-label>
              <mat-select [(ngModel)]="addForm.productType" name="simple" (selectionChange)="change()" #type1="ngModel" [ngClass]="{ 'is-invalid': f.submitted && type1.invalid }" required> 
                  <mat-option value="simple" >Simple</mat-option>
                  <mat-option value="attribute">Attribute</mat-option>
                </mat-select>
                
            </mat-form-field>
            <div
            [hidden]="type1.valid || type1.pristine"
            class="erro1"
          >Type is Required
          </div>
  </div>
  <div class="col-md-4">
    <mat-form-field class="example-full-width">
          
      <mat-label>Price</mat-label>
      <input matInput type="number" placeholder="Price" name="price123" [(ngModel)]="addForm.price" #price123="ngModel" required minlength=1  [ngClass]="{ 'is-invalid': f.submitted && price123.invalid }">
      
    </mat-form-field>
    <div
    [hidden]="price123.valid || price123.pristine"
    class="erro1"
  >Price is Required
  </div>
  </div>

  <div class="col-md-4">
      <!-- <mat-form-field>
        <mat-label>Select Catagory</mat-label>
        <mat-select [(ngModel)]="addForm.catagory_id" name="catagory_id" placeholder="Select Catagory" (selectionChange)="catada($event)" multiple #cat="ngModel" [ngClass]="{ 'is-invalid': f.submitted && cat.invalid }" required>
          <mat-option *ngFor="let catagory of catagories" [value]="catagory">{{catagory.title}}
              <mat-select multiple  *ngIf="catagory.subcatagories">
                <mat-option *ngFor="let subCatagory of catagory.subcatagories" [value]="subCatagory">{{subCatagory.title}}</mat-option>
               </mat-select> 
          </mat-option>

        </mat-select>
        
      </mat-form-field> -->
      <mat-form-field>
        <mat-label>Select Restaurant</mat-label>
        <mat-select [(ngModel)]="addForm.restaurants_id" (selectionChange)="GetRestaurantCatagories($event)" name="restaurants_id" placeholder="Select Restaurant" #restaurants_id="ngModel" [ngClass]="{ 'is-invalid': f.submitted && restaurants_id.invalid }" required>
          <mat-option *ngFor="let res of restaurants" [value]="res.id">{{res.name}}</mat-option>
  
        </mat-select>
      </mat-form-field>
      <div
    [hidden]="restaurants_id.valid || restaurants_id.pristine"
    class="erro1"
  >restaurants is Required
  </div>
</div>
  <div class="col-md-4">
  
    <mat-form-field>
      <mat-label>Select Catagory</mat-label>
      <mat-select [(ngModel)]="addForm.catagories"  name="catagory_id" (selectionChange)="enableSubctatgory($event)" [disabled]="catagories.length<=0" placeholder="Select Catagory"  multiple #cat="ngModel" [ngClass]="{ 'is-invalid': f.submitted && cat.invalid }" required>
        <mat-option *ngFor="let catagory of catagories" [value]="catagory.id">{{catagory.title}}
          <mat-select multiple *ngIf="catagory.subcatagory.length>=0" [disabled]="addForm.catagories.includes(catagory.id)" name="sub"  [(ngModel)]="addForm.subcatagories">
            <mat-option *ngFor="let subCatagory of catagory.subcatagory"  [value]="subCatagory.id">{{subCatagory.title}}</mat-option>
           </mat-select> 
        </mat-option>

      </mat-select>
      
    </mat-form-field>
    <div
  [hidden]="cat.valid || cat.pristine"
  class="erro1"
>Catagory is Required
</div>
</div>
<div class="col-md-4">
  <mat-form-field>
    <mat-label>Select Cuisine</mat-label>
    <mat-select [(ngModel)]="addForm.cuisine" name="cuisine" placeholder="Select Cuisine" #cuisine="ngModel" [ngClass]="{ 'is-invalid': f.submitted && cuisine.invalid }">
      <mat-option value="veg">Veg</mat-option>
      <mat-option value="non-veg">Non-Veg</mat-option>
      <mat-option value="both">Both</mat-option>
    </mat-select>
  </mat-form-field>
  <div
[hidden]="cuisine.valid || cuisine.pristine"
class="erro1"
>cuisine is Required
</div>
</div>
<div class="col-md-4">
  <mat-form-field>
    <mat-label>Must Try</mat-label>
    <mat-select [(ngModel)]="addForm.mustTry" name="mustTry" placeholder="Yes Or No"  #mustTry="ngModel" [ngClass]="{ 'is-invalid': f.submitted && mustTry.invalid }" >
      <mat-option>none</mat-option>

      <mat-option [value]="yes">Yes</mat-option>
      <mat-option [value]="no">No</mat-option>
    </mat-select>
  </mat-form-field>
  <div
[hidden]="mustTry.valid || mustTry.pristine"
class="erro1"
>mustTry is Required
</div>
</div>

  <div class="col-md-4">
    <mat-form-field class="example-full-width">
          
      <mat-label>Sequence</mat-label>
      <input matInput type="number" placeholder="Sequence" name="sequence" [(ngModel)]="addForm.sequence"  value="">
      
    </mat-form-field>
  </div>
  <div class="col-md-4">
    <mat-form-field class="example-full-width">
          
      <mat-label>Retail Price</mat-label>
      <input matInput type="number" placeholder="Retail Price" name="retail_price" [(ngModel)]="addForm.retail_price"  value="" #retail_price="ngModel" [ngClass]="{ 'is-invalid': f.submitted && retail_price.invalid }" required>
      
    </mat-form-field>
    <div
    [hidden]="retail_price.valid || retail_price.pristine"
    class="erro1"
  >Retail Price is Required
  </div>
  </div>

                <div class="col-md-4">
  
                  <mat-form-field class="example-full-width">
          
                    <mat-label>Dish Description</mat-label>
                    <textarea matInput placeholder="Dish Description" name="description" [(ngModel)]="addForm.description"  value="" #description="ngModel" [ngClass]="{ 'is-invalid': f.submitted && description.invalid }"></textarea>
                    
                  </mat-form-field>
                  <div
                  [hidden]="description.valid || description.pristine"
                  class="erro1"
                >Description is Required
                </div>
                <br>
                <mat-slide-toggle
                [(ngModel)]="addForm.status"
                name="status"
                #status="ngModel"
                >status</mat-slide-toggle
              >
              <mat-slide-toggle
              [(ngModel)]="addForm.popular"
              name="status"
              #status="ngModel" class="hi"
              >Popular</mat-slide-toggle
              >
               
      </div>
  <div class="col-md-4">
      <mat-slide-toggle
      [(ngModel)]="addForm.pricerelative"
      name="pricerelative"
      #pricerelative="ngModel" class="slide"
      >Reletive Price</mat-slide-toggle>
  </div>
 
  <div class="col-md-4">

  <ng-container *ngIf="!addForm.image.url; else image">
    <label  class="custom">Upload Image   
    
  <input type="file"  accept="image/*"  name="image" (change)="showPreview($event)" />

 
</label></ng-container>
<ng-template #image>
  <img src="{{addForm.image.url}}" class="img" >
</ng-template>
<div *ngIf="currentUpload && !addForm.image.url">
  Progress: {{ currentUpload?.progress }}%
  Complete
  <div class="progress">
    <div
      class="progress-bar progress-bar-animated"
      [ngStyle]="{ width: currentUpload?.progress + '%' }"
    ></div>

   
</div></div>
<div *ngIf="addForm.image.url">
    <mat-icon  (click)="deletePreviousFile()">delete</mat-icon></div>
    
</div>
   

</div>

<br>

<div *ngIf="addForm.productType=='attribute'">
  <div class="row">
  <div class="col-md-10">
    <div class="col-sm-6">
  
      <mat-form-field>
        <mat-label>Attribute Name</mat-label>
        <input matInput placeholder="Attribute Name" name="attribute_name" [(ngModel)]="addForm.attribute_name" value="" #attribute_name="ngModel" required>
        
        </mat-form-field>
        <div
        [hidden]="attribute_name.valid || attribute_name.pristine"
        class="erro1"
      >Attribute Name is Required
      </div>
        </div>
        
  </div>
  <div class="col-md-3">
      <div class="col-md-4">
  
        <mat-form-field>
          <mat-label>Price</mat-label>
          <input matInput placeholder="Price" name="price" type="number"  [(ngModel)]="price" value="">
          
          </mat-form-field>
  </div>
  </div>
  <div class="col-md-3">
  <div class="col-md-4">  
      <mat-form-field class="example-full-width">
        <mat-label>Retail Price</mat-label>
        <input matInput placeholder="Retail Price" name="rrp"  type="number" [(ngModel)]="rrp" value="">
        
      </mat-form-field>
  </div></div>
  <div class="col-md-3">
  
    <div class="col-md-12">  
  
    <mat-form-field class="example-full-width">
      <mat-label>value</mat-label>
      <input matInput placeholder="Value" name="value"   [(ngModel)]="value" value="">
      
    </mat-form-field>
  </div>
  
  </div>
  <div class="col-md-3">
  
  <div class="col-md-12"> 
  <button mat-button class="add" (click)="addAttribute()">ADD</button>
  <div *ngIf="msg" class="msg">
    {{msg}}
  </div> 
  </div></div>
        </div>     </div>
        <div class="row">
          
        </div>
<ng-container *ngFor="let a of addForm.attribute">
   
<div *ngIf="a">
<br>
<div class="row">
  <div class="col-md-3">
    <div class="col-md-4">
      <ng-container *ngIf="a.editStatus else pr"> 
      <mat-form-field>
        <mat-label>Price</mat-label>
        <input matInput placeholder="Price" name="price" type="number"  [(ngModel)]="a.price" value="" >
        
        </mat-form-field></ng-container>
        <ng-template #pr>
          {{a.price}}
        </ng-template>
</div>
</div>
<div class="col-md-3">
<div class="col-md-4">  
<ng-container *ngIf="a.editStatus else values">      <mat-form-field class="example-full-width">
      <mat-label>Retail Price</mat-label>
      <input matInput placeholder="Retail Price" name="rrp"  type="number" [(ngModel)]="a.retail_price" value=""  >
      
    </mat-form-field></ng-container>
    <ng-template #values>
      {{a.retail_price}}
    </ng-template>
</div></div>
<div class="col-md-3">

  <div class="col-md-4">  
    <ng-container *ngIf="a.editStatus else rrp1"> 
  <mat-form-field class="example-full-width">
    <mat-label>Value</mat-label>
    <input matInput placeholder="Value" name="value"   [(ngModel)]="a.value" value="" >
    
  </mat-form-field></ng-container>
  <ng-template #rrp1>
    {{a.value}}
  </ng-template>
</div>

</div>
<div class="col-md-3">
  <ng-container *ngIf="!a.editStatus;else done1">
  <button mat-button class="add" (click)="edit(a.id)">Edit</button></ng-container>
  <ng-template #done1><button mat-button class="add" (click)="edit(a.id)">Done</button></ng-template>
<button mat-button class="add" (click)="deleteAttribute(a.id)">Delete</button>

</div>
</div>
</div>
</ng-container>
      <div class="row">
          <div class="col-md-7"> 
         
          <div class="col-md-4">          <button mat-raised-button class="addDish" (click)="addDish()" [disabled]="f.invalid">ADD DISH</button></div></div>
  </div>
      </form>
      </mat-card>

  
  </div>